import { NavLink, Outlet } from "react-router-dom";
import {
  Utensils, LayoutDashboard, ShoppingCart, Grid3x3, Coffee,
  Waves, Bed, Wine, ChefHat, BookOpen, BarChart3, Sunrise,
} from "lucide-react";

const TABS = [
  { to: "/fnb",              label: "Dashboard",       icon: LayoutDashboard, end: true, testid: "fnb-tab-dashboard" },
  { to: "/fnb/pos",          label: "Restaurant POS",  icon: ShoppingCart,               testid: "fnb-tab-pos" },
  { to: "/fnb/tables",       label: "Tables",          icon: Grid3x3,                    testid: "fnb-tab-tables" },
  { to: "/fnb/kds",          label: "Kitchen Display", icon: ChefHat,                    testid: "fnb-tab-kds" },
  { to: "/fnb/bar",          label: "Bar Display",     icon: Wine,                       testid: "fnb-tab-bar" },
  { to: "/fnb/pool",         label: "Pool Orders",     icon: Waves,                      testid: "fnb-tab-pool" },
  { to: "/fnb/room-service", label: "Room Service",    icon: Bed,                        testid: "fnb-tab-rs" },
  { to: "/fnb/breakfast",    label: "Breakfast",       icon: Sunrise,                    testid: "fnb-tab-breakfast" },
  { to: "/fnb/menu",         label: "Menu",            icon: BookOpen,                   testid: "fnb-tab-menu" },
  { to: "/fnb/reports",      label: "Reports",         icon: BarChart3,                  testid: "fnb-tab-reports" },
];

export default function FnbShell() {
  return (
    <div className="space-y-6" data-testid="fnb-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <Utensils className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Food &amp; Beverage OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            One guest, one bill · Auto-routed to outlets · Revenue split by department · Immutable ledger.
          </p>
        </div>
      </div>
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet/>
    </div>
  );
}
